"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockStylesheet = exports.StylableEnv = void 0;
var tslib_1 = require("tslib");
var postcss = tslib_1.__importStar(require("postcss"));
var core_1 = require("@stylable/core");
var stylable_stylesheet_1 = require("./stylable-stylesheet");
var memory_minimal_fs_1 = require("./memory-minimal-fs");
var StylableEnv = /** @class */ (function () {
    function StylableEnv(files) {
        var _this = this;
        if (files === void 0) { files = {}; }
        this.version = 0;
        this.files = Object.keys(files).reduce(function (acc, path) {
            acc[path] = _this.createFile(files[path]);
            return acc;
        }, {});
        var _a = memory_minimal_fs_1.createMinimalFS({ files: this.files }), fs = _a.fs, requireModule = _a.requireModule;
        this.fs = fs;
        this.stylable = new core_1.Stylable('/', this.fs, requireModule);
    }
    StylableEnv.prototype.transform = function (meta) {
        this.stylable.transform(meta);
    };
    StylableEnv.prototype.getStyleSheetDriver = function (path, scope, transformationPlugins, experiments) {
        var _this = this;
        if (experiments === void 0) { experiments = { newElementree: true }; }
        return new stylable_stylesheet_1.StylesheetDriver(function () { return _this.getMetaByPath(path); }, function (_modified) { return _this.updateFS(path, _this.getMetaByPath(path).rawAst.toString()); }, function () {
            return new core_1.StylableTransformer({
                diagnostics: new core_1.Diagnostics(),
                fileProcessor: _this.stylable.fileProcessor,
                requireModule: _this.requireModule,
            });
        }, scope, transformationPlugins, experiments);
    };
    StylableEnv.prototype.getMetaByPath = function (path) {
        return this.stylable.process(path);
    };
    StylableEnv.prototype.updateFS = function (path, source) {
        this.fs.writeFileSync(path, source);
        this.version = this.files[path].v;
        this.stylable.process(path);
        return this.version;
    };
    StylableEnv.prototype.createFile = function (content) {
        return {
            content: content,
            mtime: new Date(++this.version),
            v: this.version,
        };
    };
    return StylableEnv;
}());
exports.StylableEnv = StylableEnv;
function createMockStylesheet(_a) {
    var _b = _a === void 0 ? {} : _a, source = _b.source, astRoot = _b.astRoot, onModified = _b.onModified;
    var meta = new core_1.StylableMeta(astRoot || postcss.parse(source || ''), new core_1.Diagnostics());
    return new stylable_stylesheet_1.StylesheetDriver(function () { return meta; }, onModified || (function () { return 0; }), function () {
        return new core_1.StylableTransformer({
            diagnostics: new core_1.Diagnostics(),
            fileProcessor: {
                add: function () {
                    throw new Error('not implemented in mock');
                },
                cache: {},
                postProcessors: [],
                process: function () {
                    throw new Error('not implemented in mock');
                },
                processContent: function () {
                    throw new Error('not implemented in mock');
                },
                resolvePath: function () {
                    throw new Error('not implemented in mock');
                },
            },
            requireModule: function () {
                throw new Error('requireModule not implemented in mock');
            },
        });
    });
}
exports.createMockStylesheet = createMockStylesheet;
//# sourceMappingURL=stylable-env.js.map